import { Directive } from '@angular/core';

@Directive({ selector: '[uxg-user-profile-panel-actions], [uxgUserProfilePanelActions]' })
export class UxgUserProfilePanelActionsDirective {
  constructor() {}
}
